<template>
  <section class="faqs container" id="faqs-page">
    <section class="section-pad">
      <div class="section-heading">
        <h3 class="title orange-color text-center">Fequently Asked Questions</h3>
      </div>
      <div class="section-content">
        <el-row>
          <el-col :lg="24">
            <el-collapse v-model="activeNames" @change="handleChange" accordion>
              <span v-for="(item,index) in faqs" :key="index">
                <el-collapse-item :title="item.title" :name="item.id">
                  <ul>
                    <li v-for="(item,index) in item.content" :key="index">
                      <h4>{{item.sub_title}}</h4>
                      <p>{{item.answer}}</p>
                    </li>
                  </ul>
                </el-collapse-item>
              </span>
            </el-collapse>
          </el-col>
        </el-row>
      </div>
    </section>
  </section>
</template>

<script>
import LayoutDefault from "@/layouts/LayoutDefault";

export default {
  data() {
    return {
      activeNames: [1],
      faqs: [
        {
          id: 1,
          title: "Click & Collect",
          content: [
            {
              sub_title: "What is Click & Collect ?",
              answer: "Order online and collect from the shop of your choice."
            },
           {
              sub_title: "How long will it take for my order to be ready in store?",
              answer: "48 hours for Click and Collect to be ready in store."
            },
            {
              sub_title: "How do I know when my order is ready in store?",
              answer: "You will receive a call or email from the store confirming your order is ready for collection"
            },
             {
              sub_title: "How long will my order be kept in store for collection?",
              answer: "All orders paid in full will be held for 7 days for collection. After this time there could be a slight delay in waiting for stock to arrive from our suppliers"
            },
             {
              sub_title: "What happens if I can not collect my order?",
              answer: "We can courier any order nationwide for a frieght fee if you are unable to collect."
            },
             {
              sub_title: "How do I collect my order in store?",
              answer: "Report to the front desk and provide them with your online order number. ID will be required for any order collections"
            },
             {
              sub_title: "What do I need to take with me when I collect my items?",
              answer: "Your online order number, photo proof of identity"
            },
            {
              sub_title: "How do I return items delivered by Click & Collect?",
              answer: "You can either courier these back to the store for a return or drop these off at the same store they were collected from"
            },
            {
              sub_title: "What should I do if I have any other questions regarding Click & Collect?",
              answer: "email us at colombo.store@nutron.co.nz"
            }
          ]
        },
        {
          id: 2,
          title: "Contact",
          content: [
             {
              sub_title: "Our dispatch team, for all deliveries, order and return queries",
              answer: "email us at colombo.store@nutron.co.nz"
            },
            {
              sub_title: "Our Buying & Production team",
              answer: "email us at colombo.store@nutron.co.nz"
            },
            {
              sub_title: "Our Retail team, for feedback on your retail store experience",
              answer: "email us at colombo.store@nutron.co.nz"
            }
          ]
        },
        {
          id: 3,
          title: "Emails",
          content: [
            {
              sub_title: "Our Accounts team, if you have an account card and wish to make payments or changes to your account.?",
              answer: "email us at colombo.store@nutron.co.nz"
            },
            {
              sub_title: "Why am I getting emails from NUTRON",
              answer: "When you agree to our terms and conditions you agreed to join up to our mailer."
            },
            {
              sub_title: "How do I opt out of marketing emails?",
              answer: "Unsubscribe from the mailing list either by clicking on the link on the email."
            },
            {
              sub_title: "I haven't received a validation email - what do I do?",
              answer: "email us at colombo.store@nutron.co.nz"
            }
          ]
        },
        // {
        //   id: 4,
        //   title: "Delivery",
        //   content: [
        //     {
        //       sub_title: "How long will my order be kept in store for collection?",
        //       answer: "All orders paid in full will be held for 7 days for collection. After this time there could be a slight delay in waiting for stock to arrive from our suppliers"
        //     }
        //   ]
        // },
        {
          id: 5,
          title: "Instore Orders",
          content: [
            {
              sub_title: "How do I return my Instore Order",
              answer: "Follow our returns policy."
            },
            {
              sub_title: "One of my items was cancelled, how do I get a refund?",
              answer: "Please reach us at colombo.store@nutron.co.nz"
            }
          ]
        },
        // {
        //   id: 6,
        //   title: "My Account",
        //   content: [
        //     {
        //       sub_title: "What is Click & Collect ?",
        //       answer: "Order online and collect from the shop of your choice."
        //     }
        //   ]
        // },
        // {
        //   id: 7,
        //   title: "Payment & Billing",
        //   content: [
        //     {
        //       sub_title: "What is Click & Collect ?",
        //       answer: "Order online and collect from the shop of your choice."
        //     }
        //   ]
        // },
        // {
        //   id: 8,
        //   title: "Returns",
        //   content: [
        //     {
        //       sub_title: "What is Click & Collect ?",
        //       answer: "Order online and collect from the shop of your choice."
        //     }
        //   ]
        // },
        {
          id: 9,
          title: "Shoppings",
          content: [
            {
              sub_title: "How do I search for a product?",
              answer: "In the search bar type a short description using key words for the product you wish to look up and click search."
            },
             {
              sub_title: "I have bought something but have seen it at a different price on your website",
              answer: "We will match the online price. If you see different prices please let us know by email colombo.store@nutron.co.nz"
            },
            

          ]
        }
      ]
    };
  },
  created() {
    this.$emit("update:layout", LayoutDefault);
    this.$root.$emit('closenav', false);
  },
  methods: {
    handleChange() {
      console.log();
    }
  }
};
</script>

<style scoped lang="scss">
#faqs-page {
  span {
    display: block;
  }
  .section-content {
    padding: 0 2em;
  }
  .el-collapse-item {
    .el-collapse-item__header {
      font-size: 18px !important;
      font-weight: bold;
      color: #333;
    }
  }
}
</style>